import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Payments Settings'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: 'Payments Settings',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/settings/payments',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
